import React from 'react';

import EmailLeadCapture from '@components/EmailLeadCapture';
import MarketingLeadCaptureWithApple from '@components/LockedLeadCaptureForm/MarketingLeadCaptureWithApple';
import MarketingLeadCaptureWithGoogle from '@components/LockedLeadCaptureForm/MarketingLeadCaptureWithGoogle';
import useWindowSize from '@hooks/useWindowSize';
import { Theme } from '@interfaces/global';
import { create_lead_with_oauth_path } from '@routes';
import { READER_URL } from '@src/env';
import { FormLocation } from '@utils/enums';

const LeadCaptureModalBody = ({
  articleId,
  buttonText,
  briefingGuid,
  formClassName,
  leadType,
  offerLink,
  shareGuid,
  trackingProps,
  unlockContent,
}: {
  articleId?: number;
  buttonText: string;
  briefingGuid?: string;
  disclosure?: string;
  formClassName?: string;
  leadType: string;
  offerLink: string;
  shareGuid?: string;
  trackingProps?: { [key: string]: string };
  unlockContent?: boolean;
}) => {
  const returningUri = `${READER_URL}/${offerLink}`;
  const { width: windowWidth } = useWindowSize();

  return (
    <div>
      <EmailLeadCapture
        articleId={articleId}
        buttonText={buttonText}
        briefingGuid={briefingGuid}
        formClassName={formClassName}
        formLocation={FormLocation.MarketingModal}
        includeSignInOption={true}
        inputClassName="w-full"
        isVertical={windowWidth < 768}
        leadType={leadType}
        redirectUri={offerLink}
        trackingProps={{ ...trackingProps, name: 'subscribe' }}
        shareGuid={shareGuid}
        signInOptionClass="text-center sm:text-left"
        gdprClassName="mb-16"
        theme={Theme.Dark}
        unlockContent={unlockContent}
      />

      <div className="mt-24 flex flex-col items-center md:mt-72">
        <MarketingLeadCaptureWithGoogle
          formLocation="marketing_modal"
          eventName="createLeadWithGoogle"
          verificationUri={create_lead_with_oauth_path()}
          leadType={leadType}
          returningUri={returningUri}
        />
      </div>
      <div className="mt-8 flex flex-col items-center">
        <MarketingLeadCaptureWithApple
          formLocation="marketing_modal"
          eventName="createLeadWithApple"
          verificationUri={create_lead_with_oauth_path()}
          leadType={leadType}
          returningUri={returningUri}
        />
      </div>
    </div>
  );
};

export default LeadCaptureModalBody;
